/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BridgeProxyControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param isrsCode
     * @returns number OK
     * @throws ApiError
     */
    public getBridgeHistory(
        isrsCode: string,
    ): CancelablePromise<Record<string, number>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/proxy/bridge/{isrsCode}/history',
            path: {
                'isrsCode': isrsCode,
            },
        });
    }
}
